import React from 'react';
import WrapperValidationInputGroup from "./WrapperValidationInputGroup";
import PropTypes from "prop-types";
import {RequiredValidator} from "../../validator/RequiredValidators";
import {MaximumLengthValidator, MinimunLengthValidator} from "../../validator/LengthValidators";
import {PhoneValidator} from "../../validator/PersonValidators";
import {MaskInputGroup} from "../base/MaskInputGroup";

class PhoneInput extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            mask: props.input.value.charAt(2) === "9" ? "(00) 00000-0000" : "(00) 0000-0000"
        };
    }

    handleChange(e) {
        const value = e.target ? e.target.value : e;
        this.props.onChange(value);
        let state = Object.assign(this.state);
        state.mask = value.charAt(2) === "9" ? "(00) 00000-0000" : "(00) 0000-0000";
        this.setState(state);
    }

    render() {
        return (
            <MaskInputGroup autoFocus={this.props.autoFocus} input={this.props.input} mask={this.state.mask} alert={this.props.alert}
                            onChange={this.handleChange} onBlur={this.props.onBlur}/>
        )
    }
}

let listValidators = () => {
    let validators = [];
    validators.push(new RequiredValidator());
    validators.push(new MinimunLengthValidator("", 10));
    validators.push(new MaximumLengthValidator("", 11));
    validators.push(new PhoneValidator());
    return validators;
};

const validators = {
    validators: listValidators(),
};

export const PhoneInputGroup = WrapperValidationInputGroup(PhoneInput, validators);

PhoneInputGroup.propTypes = {
    alert: PropTypes.shape({
        show: PropTypes.bool.isRequired,
        title: PropTypes.string,
        text: PropTypes.string,
        type: PropTypes.string,
        dismissible: PropTypes.bool,
        handleMessage: PropTypes.func
    }),
    input: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string,
        disabled: PropTypes.bool,
        type: PropTypes.string,
        placeholder: PropTypes.string,
        required: PropTypes.bool,
        title: PropTypes.string,
    }).isRequired,
    validateOn: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
};


// WEBPACK FOOTER //
// ./src/input/validation/PhoneInputGroup.js